
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-e13a0c0e!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DashboardMobile.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-e13a0c0e!../../node_modules/vue-loader/lib/selector?type=template&index=0!./DashboardMobile.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/layouts/DashboardMobile.vue
// module id = 504
// module chunks = 2